export default {
	title: "Fechamento de Ritual",
	closeRitual: "Fechar Ritual",
	closingDate: "Data do fechamento",
	closingTime: "Hora do fechamento",
	closingConfirm: "Confirma o fechamento deste ritual? Esta ação não pode ser desfeita.",
	noTickets: "Nenhuma ficha registrada neste ritual",
	sections: {
		messages: "Mensagens",
		return: "Retorno",
	},
	addMessage: "Adicionar mensagem",
	noMessages: "Nenhuma mensagem adicionada",
	returnType: {
		NEXT_RITUAL: "Próximo Ritual",
		SPECIFIC_RITUAL: "Ritual Específico",
		SPECIFIC_CARD: "Ficha Específica",
	},
	returnFields: {
		returnType: "Tipo de Retorno",
		selectRitual: "Selecione o ritual",
		selectAttendanceType: "Tipo de ficha",
		quantity: "Quantidade",
		indefinite: "Indefinido",
		notes: "Observações",
	},
	quickClose: {
		confirm: "Confirma o fechamento deste ritual? Esta ação não pode ser desfeita.",
	},
	messages: {
		closed: "Ritual fechado com sucesso",
		closeError: "Erro ao fechar ritual",
		alreadyClosed: "Este ritual já está fechado",
	},
	summary: {
		messagesLabel: "mensagens",
		returnsLabel: "retornos",
	},
	pendingReturns: "Retornos pendentes",
	expandAll: "Expandir todos",
	collapseAll: "Recolher todos",
};
